module.exports = __webpack_public_path__ + "jenna-2959edba712b15b729bdf9fe996ea6a9.webp";